import { lazy } from "react";

// Collector Pages  
export const LazyCollectorAnalytics = lazy(() => import("@/pages/admin/CollectorAnalyticsV2"));
export const LazyCollectorAnimalDetailsPage = lazy(() => import("@/pages/admin/CollectorAnimalDetailsPage"));
export const LazyPublicProfileSettings = lazy(() => import("@/pages/admin/PublicProfileSettings"));
export const LazyUiSettings = lazy(() => import("@/pages/admin/UiSettings"));
